import React, { useRef, useState } from 'react'
import {
  Button, Card, CardContent, CircularProgress, Container, Grid,
  IconButton, TextField, Typography
} from '@material-ui/core'
import { Add, Delete } from '@material-ui/icons'
import { Alert } from '@material-ui/lab'
import { useStyles } from '../styles'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'

function FillDetailsForm() {

  const classes = useStyles()
  const { registerUser, incrementAppState } = useAdDatabase()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const name = useRef(null)
  const prolificId = useRef(null)
  const [friendsList, setFriendsList] = useState([
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
  ])

  const handleFriendNameChange = (event, index) => {
    let list = [...friendsList]
    list[index].name = event.target.value
    setFriendsList(list)
  }

  // const handleFriendGenderChange = (event, index) => {
  //   let list = [...friendsList]
  //   list[index].gender = event.target.value
  //   setFriendsList(list)
  // }

  const handleRemoveFriend = (index) => {
    let list = [...friendsList]
    list.splice(index, 1)
    setFriendsList(list)
  }

  const handleAddFriends = () => {
    setFriendsList([...friendsList, { name: '' }])
  }

  const doFillDetails = async (event) => {
    event.preventDefault()

    // Check Prolific ID
    if (prolificId.current.value.length != 24) {
      setError('Prolific ID must contain 24 characters')
      return
    }

    setLoading(true)
    setError('')

    try {
      var userDetails = {
        name: name.current.value,
        prolificId: prolificId.current.value,
        friends: friendsList
      }

      // Upload profile details to database
      await registerUser(userDetails.prolificId, userDetails)
      incrementAppState()
    }
    catch (err) {
      console.log('Error:', err.name, err.message)
      setError('Some error occurred. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className='FillDetailsForm'>
      <Container maxWidth='sm'>
        <Card elevation={2} className={classes.cardLoginSignup}>
          <CardContent>
            <Typography variant='h4' align='center' gutterBottom>
              Hello! Please provide some details.
            </Typography>
            <hr className={classes.horizontalLine} />
            <form className={classes.form} onSubmit={doFillDetails}>
              <TextField
                margin='normal'
                required
                fullWidth
                id='name'
                type='text'
                label='Name'
                autoFocus
                inputRef={name}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                id='prolific-id'
                type='text'
                label='Prolific ID'
                inputRef={prolificId}
              />

              <Grid container spacing={1} style={{ marginTop: '8px', marginBottom: '16px' }}>
                <Grid item xs={12}>
                  <Typography variant='body1' color='textSecondary'>
                    Please share the names of your social media friends (the information will be confidential and will not be misused for any purpose):
                  </Typography>
                </Grid>
                {friendsList.map((f, i) => (
                  <Grid container item xs={12} spacing={2} justifyContent='flex-start' key={i}>
                    <Grid item xs={8}>
                      <TextField
                        required
                        fullWidth
                        type='text'
                        label={`Name ${i + 1}`}
                        value={f.name}
                        onChange={e => handleFriendNameChange(e, i)}
                      />
                    </Grid>
                    {/* <Grid item xs={3}>
                      <TextField
                        required
                        select
                        fullWidth
                        label='Gender'
                        value={f.gender}
                        onChange={e => handleFriendGenderChange(e, i)}
                      >
                        <MenuItem value='Male'>Male</MenuItem>
                        <MenuItem value='Female'>Female</MenuItem>
                      </TextField>
                    </Grid> */}
                    {i >= 5 ?
                      <Grid item xs={1}>
                        <IconButton
                          disabled={loading}
                          onClick={_ => handleRemoveFriend(i)}
                        >
                          <Delete />
                        </IconButton>
                      </Grid> :
                      <></>
                    }
                  </Grid>
                ))}
                {friendsList.length < 12 &&
                  <Grid container item justifyContent='flex-end' xs={12}
                    style={{ margin: '8px 16px' }}
                  >
                    <Button
                      disabled={loading}
                      onClick={handleAddFriends}
                      variant='contained'
                      size='small'
                      style={{ textTransform: 'none' }}
                    >
                      <Add fontSize='small' />Add more friends
                    </Button>
                  </Grid>
                }
              </Grid>

              {error &&
                <Alert variant='outlined' severity='error' style={{ marginTop: '16px' }}>
                  {error}
                </Alert>
              }

              <Button
                type='submit'
                fullWidth
                variant='contained'
                size='large'
                color='primary'
                disabled={loading}
                className={classes.submitButton}
              >
                {loading ? <CircularProgress variant='indeterminate' color='inherit' size='1.5rem' /> : 'Continue'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </Container>
    </div >
  )
}

export default FillDetailsForm
